// extracted by mini-css-extract-plugin
export var externalLink = "_as-0";
export var internalLinkLabel = "_as-1";